<template>
    <Modal2 :title="$t('message.languageSelection')" @cancel="$emit('close')" :show-footer="false">
        <div class="d-flex flex-column">
            <a-select
                v-model="selectedLang"
                class="my-2"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                :autofocus="true"
            >
                <a-select-option v-for="lang in languages" :key="lang.code" :value="lang.code">
                    {{ lang.originalName }} - {{ lang.label }} / {{ lang.code }}
                </a-select-option>
            </a-select>
            <b-button size="sm" variant="success" @click="selectLang">
                {{ $t("message.save") }}
            </b-button>
        </div>
    </Modal2>
</template>
<script>
import languages from "../../../language/languages.json";
import Modal2 from "../../common/Modal2.vue";

export default {
    name: "UpdateContactLang",
    components: { Modal2 },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        languages,
        selectedLang: {},
    }),
    mounted() {
        this.selectedLang = this.contact.preferredLang;
    },
    methods: {
        selectLang() {
            this.$emit("save", this.selectedLang);
            this.$emit("close");
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
    },
};
</script>
